import RadioButtons, {type RadioButtonsOption} from "../common/RadioButtons";
import Tooltip from "../common/Tooltip";

interface ChoiceFormFieldProps<T> {
  name: string,
  labelText: string,
  testId: string,
  tooltip?: string
  value: T,
  options: Array<RadioButtonsOption<T>>,
  onChange: (value: T) => void
}

/**
 * Wizard related choice (option) value form component.
 */
export function ChoiceFormField<T extends string | number | readonly string[] | null | undefined>(props: Readonly<ChoiceFormFieldProps<T>>): React.ReactElement {
  const {name, labelText, testId, tooltip, value, options, onChange} = props
  return (
    <>
      <label>{labelText}</label>
      {tooltip && <Tooltip title={tooltip}/>}
      <RadioButtons
        data-testid={testId}
        name={name}
        value={value}
        options={options}
        onChange={onChange}
      />
    </>
  )
}
